import debug from 'bows';
import Accordion from './flexible-content/_accordion';
import PlayworksNearYou from './flexible-content/_playworks-near-you';
import Hero from './flexible-content/_hero';
import Stories from './flexible-content/_stories';
import News from './flexible-content/_news';
import TabsCards from './flexible-content/_tabs-cards';
import ResourceCollection from './flexible-content/_resource-collection';

const log = debug('flex-content');

class FlexibleContent {

	constructor() {
		this.nodes = Array.prototype.slice.call(document.querySelectorAll('.flex-layout'));
		if (!this.nodes.length) {
			return;
		}

		this.dict = {
			// 'playworks-near-you': PlayworksNearYou,
			accordion: Accordion,
			hero: Hero,
			stories: Stories,
			news: News,
			'tabs-cards': TabsCards,
			'resource-collection': ResourceCollection,
		}

		this.controllers = this.nodes.filter((node) => {
			return this.dict[node.dataset.layout];
		}).map((node) => {
			return new this.dict[node.dataset.layout](node);
		});
	}
}

export default FlexibleContent;
